<template>
  <div class="extendedAboutContainer w-100">
    <MarketingRow
      :backgroundColor="premierAboutContent.backgroundColor"
      :body="premierAboutContent.body"
      :noAssetBackground="premierAboutContent.noAssetBackground"
      :textSide="premierAboutContent.textSide"
      :title="premierAboutContent.title"
      :titleType="premierAboutContent.titleType"
    >
      <template v-slot:marketingContent>
        <BImgLazy
          :alt="premierAboutContent.title.join(' ')"
          :class="{ overflowImage: premierAboutContent.overflowImage, 'contain': premierAboutContent.containImage }"
          :src="!isMobile ? premierAboutContent.imageUrlDesktop : premierAboutContent.imageUrlMobile"
        />
      </template>
    </MarketingRow>
    <VerticalIconMessage :messages="premierTripleIconMessages" />
    <MarketplaceDescription
      :body="premierDescription.body"
      :darkButtonLink="premierDescription.darkButtonLink"
      :darkButtonText="premierDescription.darkButtonText"
      :defaultButtonLink="premierDescription.defaultButtonLink"
      :defaultButtonText="premierDescription.defaultButtonText"
      :desktopImage="premierDescription.desktopImage"
      :mobileImage="premierDescription.mobileImage"
      :title="premierDescription.title"
    />
    <div class="bg-gradient-light-gray py-3">
      <MarketingRow
        :backgroundColor="ourRates.backgroundColor"
        :body="ourRates.body"
        :noAssetBackground="ourRates.noAssetBackground"
        :textSide="ourRates.textSide"
        :title="ourRates.title"
        :titleType="ourRates.titleType"
      >
        <template v-slot:marketingContent>
          <BImgLazy
            :alt="ourRates.title.join(' ')"
            :class="{ overflowImage: ourRates.overflowImage, 'contain': ourRates.containImage }"
            :src="!isMobile ? ourRates.imageUrlDesktop : ourRates.imageUrlMobile"
          />
        </template>
      </MarketingRow>
      <PricesGridRow
        :backgroundColor="premierFees.backgroundColor"
        :bodyText="premierFees.bodyText"
        :hasBorderTop="premierFees.hasBorderTop"
        :priceSections="premierFees.priceSections"
        :showSubmitButton="premierFees.showSubmitButton"
        :smallTitle="premierFees.smallTitle"
        :title="premierFees.title"
      />
    </div>
  </div>
</template>

<script>
import { BImgLazy } from 'bootstrap-vue';
import PricesGridRow from './PricesGridRow.vue';
import VerticalIconMessage from './VerticalIconMessage.vue';
import MarketplaceDescription from './MarketplaceDescription.vue';
import MarketingRow from '../../homepage/components/MarketingRow.vue';
import { premierAboutContent, premierDescription, premierFees, premierTripleIconMessages } from '../constants/extendedConstants';
import { ourRates } from '../constants/singleMarketplaceConstants';
import { baseIsMobile } from '../../marketplaces/mixins';

export default {
  name: 'ExtendedAbout',
  components: {
    BImgLazy,
    PricesGridRow,
    MarketingRow,
    MarketplaceDescription,
    VerticalIconMessage
  },
  mixins: [baseIsMobile],
  data() {
    return {
      ourRates,
      premierAboutContent,
      premierDescription,
      premierFees,
      premierTripleIconMessages
    };
  }
};
</script>
